import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontRightSideshaftProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function FrontRightSideshaft(props: FrontRightSideshaftProps) {
  return (
    <svg
      width="30"
      height="57"
      viewBox="0 0 30 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 147, left: 267}}
      onClick={props.onClick}
    >
      <path
        d="M3 48H7C7 48 5 48 5 46C5 44 7 44 7 44H9C9 44 7 44 7 42C7 40 9 40 9 40H11C11 40 9 40 9 38C9 36.25 10.5312 36.0313 10.9141 36.0039L11 36V1H19V36C19 36 21 36 21 38C21 40 19 40 19 40H21C21 40 23 40 23 42C23 44 21 44 21 44H23C23 44 25 44 25 46C25 48 23 48 23 48H27C27 48 29 48 29 50V56H1V50C1 48 3 48 3 48Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M19.0002 36L19 1H11L11.0002 36"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M19 36H15H11C11 36 9 36 9 38C9 40 11 40 11 40H15H19C19 40 21 40 21 38C21 36 19 36 19 36Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M21 40H15H9C9 40 7 40 7 42C7 44 9 44 9 44H15H21C21 44 23 44 23 42C23 40 21 40 21 40Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M23 44H15H7C7 44 5 44 5 46C5 48 7 48 7 48H15H23C23 48 25 48 25 46C25 44 23 44 23 44Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M27 48H15H3C3 48 1 48 1 50V56H29V50C29 48 27 48 27 48Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
